import { create } from 'zustand';

const useSidebarActiveButtonStore = create((set) => ({
    activeButton: '',
    setActiveButton: (activeButton) => set(() => ({ activeButton: activeButton }))
}));

export default useSidebarActiveButtonStore;